var _path, _rect, _rect2, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgentChat = function SvgAgentChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 12.2a6.4 6.4 0 0 1 12.8 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.2,
    height: 6.6,
    x: 6.9,
    y: 10.8,
    rx: 2.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 4.6,
    x: 4.1,
    y: 12.4,
    rx: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 4.6,
    x: 17.1,
    y: 12.4,
    rx: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17v.6a2 2 0 0 1-2 2h-2.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M18.6 3.4c.28 1.32.94 1.98 2.26 2.26-1.32.28-1.98.94-2.26 2.26-.28-1.32-.94-1.98-2.26-2.26 1.32-.28 1.98-.94 2.26-2.26"
  })));
};
export default SvgAgentChat;